/** Old Mobile condition grades + per-unit QC checklist */

export const OLD_MOBILE_GRADES = ['A+', 'A', 'B+', 'B', 'C', 'D'];

export const OLD_MOBILE_GRADE_OPTIONS = [
  { value: 'A+', label: 'A+ (Excellent — like new)' },
  { value: 'A', label: 'A (Very good — minor wear)' },
  { value: 'B+', label: 'B+ (Good — light wear)' },
  { value: 'B', label: 'B (Fair — visible wear)' },
  { value: 'C', label: 'C (Average — noticeable wear)' },
  { value: 'D', label: 'D (Poor — heavy wear / parts only)' }
];

export const IMEI_QC_KEYS = [
  { key: 'display', label: 'Display Screen' },
  { key: 'touch', label: 'Touch Function' },
  { key: 'rearCamera', label: 'Rear Camera' },
  { key: 'frontCamera', label: 'Front Camera' },
  { key: 'speaker', label: 'Speaker' },
  { key: 'microphone', label: 'Microphone' },
  { key: 'wifi', label: 'WiFi' },
  { key: 'bluetooth', label: 'Bluetooth' },
  { key: 'network', label: 'Network / SIM' },
  { key: 'charging', label: 'Charging' },
  { key: 'fingerprint', label: 'Fingerprint' },
  { key: 'faceUnlock', label: 'Face Unlock' },
  { key: 'buttons', label: 'Buttons' },
  { key: 'backPanel', label: 'Back Panel' },
  { key: 'body', label: 'Body / Frame' },
  { key: 'simTray', label: 'SIM Tray' },
  { key: 'vibration', label: 'Vibration' },
  { key: 'batteryCheck', label: 'Battery (charge/hold)' },
  { key: 'others', label: 'Others' }
];

export function buildDefaultUnitQcReport() {
  const o = {};
  IMEI_QC_KEYS.forEach(({ key }) => {
    o[key] = true;
  });
  return o;
}

/** Labels map for Inventory IMEI tables */
export const UNIT_QC_LABELS = Object.fromEntries(
  IMEI_QC_KEYS.map(({ key, label }) => [key, label])
);

export function formatOldMobileGradesSummary(product) {
  if (!product || product.category !== 'Old Mobile') return '';
  const available = (product.imeiTracking || []).filter((u) => u.status === 'available');
  const fromUnits = [
    ...new Set(
      available
        .map((u) => String(u.unitConditionGrade || '').trim())
        .filter(Boolean)
    )
  ];
  if (fromUnits.length) return fromUnits.join(', ');
  const legacy = String(product.specs?.conditionGrade || '').trim();
  return legacy || '';
}

export function gradeBadgeClass(grade) {
  const g = String(grade || '').trim();
  if (g === 'A+') return 'bg-success';
  if (g === 'A') return 'bg-primary';
  if (g === 'B+') return 'bg-info text-dark';
  if (g === 'B') return 'bg-warning text-dark';
  if (g === 'C') return 'bg-secondary';
  if (g === 'D') return 'bg-danger';
  return 'bg-light text-dark border';
}
